function checkShippingDate(){

  const youbiJp = ["日", "月", "火", "水", "木", "金", "土"];

  const currentDate = new Date();
  const tomorrowDate = new Date();
  tomorrowDate.setDate(currentDate.getDate() + 1);

  const dayOfWeek = currentDate.getDay();
  const isWeekday = dayOfWeek >= 1 && dayOfWeek <= 4;

  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1;
  const currentDay = currentDate.getDate();
  const currentYoubi = youbiJp[currentDate.getDay()];

  const tomorrowYear = tomorrowDate.getFullYear();
  const tomorrowMonth = tomorrowDate.getMonth() + 1;
  const tomorrowDay = tomorrowDate.getDate();
  const tomorrowYoubi = youbiJp[tomorrowDate.getDay()];

  const shipping_date = document.getElementById('delivery-info_date');
  if(!shipping_date){return;}

  if (currentDate.getHours() >= 0 && currentDate.getHours() < 12) {
    //【全日】0時から13時までの処理;
    shipping_date.innerHTML = "13時までの決済確認で<span class='delivery_date'>本日"+currentMonth+"/"+currentDay+"（"+currentYoubi+"）"+"出荷！</span>";
  }else{
    //【全日】13時から24時までの処理;
    shipping_date.innerHTML = "明日13時までの決済確認で、<span class='delivery_date'>明日"+tomorrowMonth+"/"+tomorrowDay+"（"+tomorrowYoubi+"）"+"出荷！</span>";
  }

  setTimeout(checkShippingDate, 60000);
}

if(document.getElementById('delivery-info')){
  checkShippingDate();
}

/*---*/

(function() {
  function easeOutQuart(x) {
    return 1 - Math.pow(1 - x, 4);
  }

  function animateScroll(targetPosition, duration, easingFn) {
    const start = window.scrollY;
    const distance = targetPosition - start;
    const startTime = performance.now();

    function step(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const ease = easingFn(progress);
      window.scrollTo(0, start + distance * ease);

      if (elapsed < duration) {
        requestAnimationFrame(step);
      }
    }

    requestAnimationFrame(step);
  }

  const toCartBaloonContainer = document.getElementById('to-cart-baloon-container');

  if (toCartBaloonContainer) {
    const showPoint = window.innerHeight * 1.9;
    const couponBaloonSwitch = document.getElementById('coupon-baloon-switch');

    function onScroll() {
      const scrollTop = window.scrollY;
      if (scrollTop > showPoint) {
        toCartBaloonContainer.classList.add('__on');
        if (couponBaloonSwitch) couponBaloonSwitch.classList.add('__on');
      } else {
        toCartBaloonContainer.classList.remove('__on');
        if (couponBaloonSwitch) couponBaloonSwitch.classList.remove('__on');
      }
    }

    window.addEventListener('scroll', onScroll);
    onScroll(); // 初回呼び出し

    const variantSelector = document.querySelector('variant-selects');
    const label = document.getElementById('to-cart-baloon_label');
    const button = document.getElementById('to-cart-baloon_button');

    if (variantSelector) {
      if (label) label.textContent = "カラー・サイズを選ぶ";
      if (button) {
        button.addEventListener('click', function () {
          const elementPosition = variantSelector.getBoundingClientRect().top + window.scrollY;
          const offsetPosition = elementPosition - 80;
          animateScroll(offsetPosition, 100, easeOutQuart);
        });
      }
    } else {
      if (label) label.textContent = "ご購入はこちら";
      if (button) {
        button.addEventListener('click', function () {
          const productInfoContainer = document.querySelector('.product__info-wrapper');
          const offsetPosition = productInfoContainer ? productInfoContainer.getBoundingClientRect().top + window.scrollY - 80 : 0;
          animateScroll(offsetPosition, 100, easeOutQuart);
        });
      }
    }
  }
})();
